<template>
  <div>
    <page-intro>
      <template v-slot:heading>Мои базы</template>
      <template v-slot:info>
        <div class="mb-20">
          Создавайте и переносите свои базы 1С в облако. Управление доступно напрямую из личного кабинета. Для публикации базы по ссылке воспользуйтесь формой обратной связи.
        </div>
        <span class="link flex-nowrap flex-y-center" @click="guaranteeModalOpened = true">
          <span class="icon icon-current icon-sm mr-4" v-html="shieldIcon" />
          Гарантия сохранности базы
        </span>
      </template>
      <template v-slot:controls>
        <el-button
          type="primary"
          class="w-100 mb-20"
          :disabled="!$store.state.user.accInfo.isAdmin"
          @click="creatingModalOpened = true">
          Создать базу
        </el-button>
        <el-button
          class="w-100 mb-20 ml-0"
          type="primary"
          plain
          :disabled="!$store.state.user.accInfo.isAdmin"
          @click="backupModalOpened = true">
          Запрос бекапа
        </el-button>
        <instruction-link name="baseCreation">Инструкция по созданию</instruction-link>
      </template>
    </page-intro>
    <div class="stack-md">
      <div class="widget">
        <div class="widget__head">
          <div class="flex-self-grow-1 flex-y-center flex-x-between">
            <div>
              <el-checkbox
                v-model="allDatabasesChecked"
                class="mr-12">
                Выбрать все
              </el-checkbox>
            </div>
            <div class="flex-row">
              <div class="mr-12">
                <el-button
                  class="w-100" size="medium" type="primary"
                  plain
                  :disabled="!databases.length || !$store.state.user.accInfo.isAdmin"
                  @click="handleRightsClick">
                  Права доступа к базам
                </el-button>
              </div>
            </div>
          </div>
        </div>
        <div class="widget__body">
          <non-data-stub :stub-data="databases">
            <div v-for="(database, i) in databases" :key="database.id">
              <div v-if="i !== 0" class="divider" />
              <div class="flex-y-center flex-x-between">
                <div>
                  <div class="flex-y-center flex-nowrap">
                    <el-checkbox
                      :value="checkedDatabases.includes(database.id)"
                      @change="switchCheckedDatabase(database.id)" />
                    <div class="h3">{{ database.name }} ({{ database.size }}гб)</div>
                  </div>
                  <div v-if="database.serverPath" class="mt-12 text-muted ml-32 overflow-wrap">
                    На сервере: {{ database.serverPath }}
                  </div>
                  <div v-if="database.link" class="mt-12 text-muted ml-32 overflow-wrap">
                    Веб-адрес: <a class="link" :href="database.link">{{ database.link }}</a>
                  </div>
                </div>
                <div v-if="$store.state.user.accInfo.isAdmin" class="database-list__row__constrols">
                  <a v-if="database.isPublished" class="flex-x-center link-muted icon-text-align" @click="removeFromPublication(database)">
                    <span class="icon icon-current mr-8 el-icon-document-remove" />
                    Снять с публикации
                  </a>
                  <a v-else class="flex-x-center link-muted icon-text-align" @click="publication(database)">
                    <span class="icon icon-current mr-8 el-icon-document-checked" />
                    Заявка на публикацию
                  </a>
                </div>
              </div>
            </div>
          </non-data-stub>
        </div>
      </div>
      <w-access />
    </div>

    <guarantee-modal :visible.sync="guaranteeModalOpened" />
    <creating-modal :visible.sync="creatingModalOpened" />
    <users-modal :visible.sync="usersModalOpened" :checked-databases="checkedDatabases" />
    <backup-modal :visible.sync="backupModalOpened" />
  </div>
</template>

<script>
  import PageIntro from '@/components/PageIntro.vue'
  import wAccess from '@/components/Access.vue'
  import GuaranteeModal from './GuaranteeModal.vue'
  import CreatingModal from './CreatingModal.vue'
  import InstructionLink from '@/components/InstructionLink.vue'
  import UsersModal from './UsersModal.vue'
  import BackupModal from './BackupModal.vue'
  import NonDataStub from '@/components/stub/NonDataStub.vue'
  import { mapState } from 'vuex'

  export default {
    name: 'DatabasesPage',

    components: {
      PageIntro,
      wAccess,
      GuaranteeModal,
      CreatingModal,
      UsersModal,
      BackupModal,
      InstructionLink,
      NonDataStub
    },

    data() {
      return {
        checkedDatabases: [],
        checkAllDatabases: false,

        guaranteeModalOpened: false,
        creatingModalOpened: false,
        usersModalOpened: false,
        transferModalOpened: false,
        publishModalOpened: false,
        unpublishModalOpened: false,
        backupModalOpened: false,

        shieldIcon: require('@/assets/img/icons/shield-ok.svg')
      }
    },

    computed: {
      ...mapState({
        databases: state => state.databases.databases,
        users: state => state.users.users
      }),

      baseCreationInstruction() {
        return this.$store.getters.getInstructionRoute('baseCreation')
      },

      allDatabasesChecked: {
        get() {
          return this.databases.length === this.checkedDatabases.length && this.databases.length
        },
        set(val) {
          if (val) {
            this.checkedDatabases = this.databases.map(db => db.id)
          } else {
            this.checkedDatabases = []
          }
        }
      }
    },

    methods: {
      switchCheckedDatabase(id) {
        if (this.checkedDatabases.includes(id)) {
          this.checkedDatabases = this.checkedDatabases.filter(checkedId => checkedId !== id)
        } else {
          this.checkedDatabases.push(id)
        }
      },

      handleRightsClick() {
        if (!this.checkedDatabases.length) {
          this.$notify({
            title: 'Изменение прав доступа',
            message: 'Сначала выберите базы, для которых нужно изменить права доступа',
            type: 'warning'
          })
        } else {
          this.usersModalOpened = true
        }
      },

      publication(database) {
        this.$confirm(`После публикации вы сможете перейти в базу ${database.name} по ссылке из личного кабинета`, 'Публикация базы', {
          confirmButtonText: 'Опубликовать',
          cancelButtonText: 'Отмена',
          confirmButtonClass: 'bg-success',
          type: 'info'
        }).then(async () => {
          await this.$http.publishDatabase({ databaseId: database.id })

          this.$notify({
            title: 'Публикация базы',
            message: 'Заявка на публикацию базы данных отправлена',
            type: 'success'
          })
        })
      },

      removeFromPublication(database) {
        this.$confirm(`После снятия базы с публикации база ${database.name} перестанет быть доступной из личного кабинета`, 'Снятие с публикации', {
          confirmButtonText: 'Снять с публикации',
          cancelButtonText: 'Отмена',
          confirmButtonClass: 'bg-warning',
          type: 'warning'
        }).then(async () => {
          await this.$http.publishDatabase({ databaseId: database.id })

          this.$notify({
            title: 'Снятие с публикации',
            message: 'Заявка на снятие базы с публикации отправлена',
            type: 'success'
          })
        })
      }
    }
  }
</script>

<style lang="scss" scoped>
  .database-list__row__constrols {
    width: 270px;
  }
</style>